import axios from 'axios';
import { configs } from '../app/app-configs';
import { Exercise, ExerciseRequest } from './model/workout.model';

export const getExercises = async (searchTerm: string, muscleGroup: string): Promise<Exercise[]> => {
    return await axios.get(`${configs.BASE_URL}/exercises`, {
        params: {
            search: searchTerm,
            muscleGroup: muscleGroup
        }
    }).then((res) => {
        return res.data;
    });
};

export const createExercise = async (
    request: ExerciseRequest
): Promise<Exercise> => {
    return await axios
        .post(`${configs.BASE_URL}/exercises`, request)
        .then((res) => {
            return res.data as Exercise;
        });
};

export const updateExercise = async (
    request: ExerciseRequest
): Promise<Exercise> => {
    return await axios
        .put(`${configs.BASE_URL}/exercises/${request.id}`, request)
        .then((res) => {
            return res.data as Exercise;
        });
};

export const deleteExercise = async (id: number): Promise<number> => {
    return await axios
        .delete(`${configs.BASE_URL}/exercises/${id}`)
        .then((res) => {
            return res.data;
        });
};
